import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const isChecked = event.target.checked
    this.element.querySelectorAll('input[type="checkbox"]')
      .forEach(checkbox => {
        if (checkbox !== event.target) {  // Don't update the "Select All" checkbox itself
          checkbox.checked = isChecked
        }
      })
  }
}
